
import { Injectable } from '@angular/core';
declare global {
  interface Window {
    DD_RUM: any;
  }
}

@Injectable({
    providedIn: 'root'
})

export class MonitoringService {
  /**
   * Sends monitoring logs using the Datadog RUM API.
   * @param action The action name to log.
   * @param actionValue Optional value associated with the action.
   */
  sendMonitoringLogs(action: string, actionValue: string = ''): void {
    window?.DD_RUM?.addAction?.(action, { value: actionValue });
  }
}